module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAACLSURBVCiRlY6xDYJgEEaf/wwMYmNhb8E2OAodM7CDCXEDOkaAASxMLJ6FhyEGDP+XXC657313B7lSO/erS0ALPHfsfgBtAibgBPR/4B44AxNxqlELtV55ow6vUWVhDOpRLdUxqozZMEPLgOpLrWJjoV5j9tVBdeXnW/TLr7EV2FTKgefAPYPPYT96A1N4xlRKRWCSAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/email.png
// module id = wF+D
// module chunks = 1